var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-settings"},[(!_vm.show || !_vm.billingPlans)?_c('base-loader',{key:"loader"}):_vm._l((_vm.billingPlans),function(plan,key){return _c('plan',{key:key,attrs:{"plan":plan,"show":_vm.show}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }